import { gql } from '@apollo/client';

export const GET_CRM_PIPELINE = gql`
    query GetCrmPipeline {
        getCrmPipeline {
            _id
            stages {
                key
                name
                order
                color
                isWon
                isLost
                statuses {
                    label
                    fromDays
                    toDays
                    color
                }
            }
        }
    }
`;

export const LIST_CRM_PIPELINES = gql`
    query ListCrmPipelines {
        listCrmPipelines {
            _id
            boardId
            boardName
            name
            order
            stages {
                key
                name
                order
                color
                isWon
                isLost
                statuses {
                    label
                    fromDays
                    toDays
                    color
                }
            }
        }
    }
`;
